import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayoutTop"><Path d="M21 7V21H3V7H21Z" fill="currentColor"/><Path d="M21 3V5H3V3H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutTop;
